import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './common.css';
import './custom.css';
import { MYMRoutes } from './MYMRoutes';

export const App = () => {

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const router = createBrowserRouter(MYMRoutes, { basename: baseUrl });

  return (
      <RouterProvider router={router} />
  );
}

